import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ClassificationCModel } from '../models/ClassificationCModel';
import { URLsConfig } from '../URLsConfig';
import { CategoryModel } from '../models/ClassificationModel';
@Injectable()
export class ClassificationCService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getClassificationCLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<ClassificationCModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ClassificationC/ClassificationCLookupTop', options);
  }

  public getClassificationC(ClasCode: string , comCode: string) {
    let params = new HttpParams();
      params = params.append("ClasCode", ClasCode);
      params = params.append("compCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<ClassificationCModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClassificationC/GetClassificationC',options);
  }
  public DeleteClassificationC(ClasCode: string , comCode: string) {
    let params = new HttpParams();
      params = params.append("ClasCode", ClasCode);
      params = params.append("compCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<ClassificationCModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClassificationC/DeleteClassificationC',options);
  }
  public AddClassificationC(ClassificationC: ClassificationCModel) {
    return this.http.post<ClassificationCModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClassificationC/AddClassificationC', ClassificationC);
}

public getCategoryLookupTop() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<CategoryModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Category/CategoryLookup', options);
}

public getCategory(CatCode: string) {
let params = new HttpParams();
  params = params.append("CatCode", CatCode);
  const options = {
      params: params
  };
  return this.http.get<CategoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/Category/GetCategory',options);
}
public DeleteCategory(CatCode: string ) {
let params = new HttpParams();
  params = params.append("CatCode", CatCode);
  const options = {
      params: params
  };
  return this.http.get<CategoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/Category/DeleteCategory',options);
}
public AddCategory(Category: CategoryModel) {
return this.http.post<CategoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/Category/AddCategory', Category);
}
}
